export default __webpack_public_path__ + "static/media/H1001b.1678fada.mp3";